export function toLowerCaseDeep(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(toLowerCaseDeep);
  } else if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [k.toLowerCase(), toLowerCaseDeep(v)])
    );
  }
  return obj;
}